import api from '@/utils/api';
import {
    GET_GENERAL_EXAM_BY_CUSTOMER,
    UPDATE_SPECIFIC_GENERAL_EXAM,
    CREATE_SPECIFIC_GENERAL_EXAM,
    REMOVE_GENERAL_EXAM,
    GET_SPECIFIC_GENERAL_EXAM
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * 🔹 Lấy thông tin khám tổng quát theo khách hàng
 */
export const getGeneralExamsByCustomer = (filter, customerId) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/general-exams/customer/${customerId}`, { params: filter })
            .then(res => {
                dispatch({
                    type: GET_GENERAL_EXAM_BY_CUSTOMER,
                    payload: res.data.data
                });
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
    });
};

/**
 * Lấy TBản ghi cụ thể theo ID
 */
export const getSpecificGeneralExam = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/general-exams/${id}`)
            .then((res) => {
                dispatch({ type: GET_SPECIFIC_GENERAL_EXAM, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể lấy chi tiết Treatment Session'
                );
                reject(err);
            });
    });
};

/**
 * 🔹 Tạo mới thông tin khám tổng quát
 */
export const createGeneralExam = (customerId, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post(`/general-exams/customer/${customerId}`, data)
            .then(res => {
                dispatch({
                    type: CREATE_SPECIFIC_GENERAL_EXAM,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Tạo phiếu khám tổng quát thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Có lỗi xảy ra khi cập nhật!');
                reject(err);
            });
    });
};

/**
 * 🔹 Cập nhật thông tin khám tổng quát
 */
export const updateGeneralExam = (customerId, id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/general-exams/customer/${customerId}/${id}`, data)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_GENERAL_EXAM,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Cập nhật phiếu khám tổng quát thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Có lỗi xảy ra khi cập nhật!');
                reject(err);
            });
    });
};

/**
 * 🔹 Duyệt phiếu khám tổng quát
 */
export const approveGeneralExam = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/general-exams/approve/${id}`)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_GENERAL_EXAM,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Đã xác nhận phiếu khám tổng quát!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể duyệt phiếu!');
                reject(err);
            });
    });
};

/**
 * 🔹 Hủy duyệt phiếu khám tổng quát
 */
export const unapproveGeneralExam = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/general-exams/unapprove/${id}`)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_GENERAL_EXAM,
                    payload: res.data.data
                });
                NotificationManager.success(res.data.msg || 'Đã hủy xác nhận phiếu khám tổng quát!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể hủy duyệt phiếu!');
                reject(err);
            });
    });
};

/**
 * Xoá một hoặc nhiều bản ghi
 */
export const removeGeneralExam = (ids) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api
            .delete('/general-exams', { data: { ids } })
            .then((res) => {
                dispatch({ type: REMOVE_GENERAL_EXAM, payload: ids });
                NotificationManager.success('Xoá thành công!');
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(
                    err.response?.data?.msg || 'Xoá thất bại'
                );
                reject(err);
            });
    });
};